import { Menu } from 'antd';
import React, { memo, useCallback } from 'react';
import cn from 'classnames';
import DropdownButton from '../../components/DropdownButton/DropdownButton';
import pageSizes from './pageSizes';
import styles from './PageSizeButton.module.scss';

const PageSizeButton = ({
  pageSize: selectedPageSize = pageSizes[0],
  setPageSize,
  getPopupContainer,
  buttonClassName,
  className,
  invert = false,
  showText = true,
  customText,
}) => {
  const onPageSizeChange = useCallback(
    ({ key }) => setPageSize(+key),
    [setPageSize]
  );
  const menu = (
    <Menu>
      {pageSizes.map((pageSize) => {
        return (
          <Menu.Item key={pageSize} onClick={onPageSizeChange}>
            по {pageSize} {customText ? customText : ''}
          </Menu.Item>
        );
      })}
    </Menu>
  );
  return (
    <DropdownButton
      buttonClassName={cn(styles.button, buttonClassName)}
      className={className}
      prevText={showText ? 'Строк на странице' : ''}
      text={`по ${selectedPageSize} ${customText ? customText : ''}`}
      overlay={menu}
      value={selectedPageSize}
      getPopupContainer={getPopupContainer}
      invert={invert}
    />
  );
};

export default memo(PageSizeButton);
